import React from 'react';
import { useAppContext } from '../context/AppContext';

const Notifications = () => {
  const { notifications } = useAppContext();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={`p-4 rounded-lg shadow-lg max-w-sm animate-slide-in ${
            notification.type === 'success' ? 'bg-green-500 text-white' :
            notification.type === 'error' ? 'bg-red-500 text-white' :
            notification.type === 'warning' ? 'bg-yellow-500 text-white' :
            'bg-blue-500 text-white'
          }`}
        >
          <h4 className="font-bold">{notification.title}</h4>
          <p className="text-sm">{notification.message}</p>
        </div>
      ))}
    </div>
  );
};

export default Notifications;